import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { MonthlyTradingReportData } from "../types";

export const useTradesReportData = () => {
	const data = useSelector<StoreType, MonthlyTradingReportData[] | undefined>(
		s => s.data.reports.securityCommission.monthlyTrade.data
	);

	const dispatch = useDispatch();
	const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [dispatch]);

	return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
